// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__U_5YA","advantages":"styles_advantages__3eSik","wrapper":"styles_wrapper__2LfPa","item":"styles_item__JPaiJ","icon":"styles_icon__2ZdOI"};